// extracted by css-extract-rspack-plugin
export default {"list":"_tc6Dx"};